/**
 * AgentEnquiry
 * 
 * @Author: Focci
 * @Date: 2024-01-17 10:26:44
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-17 10:26:44
 */

import PropTypes from 'prop-types'
import useApp from '@hook/useApp'
import { isArray } from 'lodash-es'
import { useMemo } from 'react'
import FloatingDialog from '../FloatingDialog'
import AgentEnquiryHead from './AgentEnquiryHead'
import AgentEnquiryAgents from './AgentEnquiryAgents'
import AgentEnquiryForm from './AgentEnquiryForm'
import AgentsSwiper from './AgentsSwiper'

export default function AgentEnquiry({
  open = false,
  onClose = () => {},
  onSuccess = () => {},
  // { houseId, or... }
  trackParams,
  // [{ id, name, phone, avatar, language }]
  agents = [],
  // { officeIcon, officeColor, fontColor }
  office = {},
  // form props { id, type, agentId, body }
  formProps,
  house,
}) {
  const { isMobile } = useApp()

  const hasAgents = useMemo(() => isArray(agents) && agents.length > 0, [agents])
  
  return (
    <FloatingDialog
      DialogProps={{ open, fullScreen: isMobile }}
    >
      <AgentEnquiryHead 
        onClick={onClose}
        {...office}
      />
      {hasAgents && !isMobile && (
        <div className="px-2 pt-2 -mb-6">
          <AgentEnquiryAgents 
            agents={agents} 
            trackParams={trackParams} 
            house={house}
          />
        </div>
      )}
      {hasAgents && isMobile && (
        <AgentsSwiper agents={agents} />
      )}
      <div className="px-6 pb-6 pt-6">
        <AgentEnquiryForm {...formProps} house={house} onSuccess={onSuccess} />
      </div>
    </FloatingDialog>
  )
}

AgentEnquiry.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  agents: PropTypes.array,
  office: PropTypes.object,
}
